import { useParams } from 'react-router-dom';

import { QuestionnaireMode } from '../config/DiactiveTypes';
import Questionnaire from '../components/questionnaires/Questionnaire';

const ViewQuestionnaire = () => {
  const { phase, questionnaireId, patientId } = useParams();
  return (
    <Questionnaire
      mode={QuestionnaireMode.View}
      phase={phase}
      questionnaireId={questionnaireId}
      patientId={patientId}
    />
  );
};

export default ViewQuestionnaire;